import React, {Fragment, Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {translationsByMessageIdSelector} from "../../modules/app"
import {Table} from 'react-bootstrap'
import {push} from 'react-router-redux'
import {routesUrls} from "../../settings/routes"
import { syncTest, syncProd, syncDemo } from './Transactions/actions'
import Spiner from '../helpers/Spiner/Spiner'
import {toastr} from 'react-redux-toastr'

class Translations extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
	constructor(props) {
		super(props)
		this.state = {
			spinner: false
		}
	}
 
	syncTestClick = async() => {
		let {formatMessage} = this.context
		try {
			this.setState({spinner: true})
			await syncTest();
			toastr.success(formatMessage('titleSyncTrSuccess'), formatMessage('messageSyncTrSuccess'));
			this.setState({spinner: false})
		} catch (error) {
			this.setState({spinner: false})
			toastr.error(formatMessage('titleSyncTrError'), formatMessage('messageSyncTrError'));
		}
	}

	syncDemoClick = async() => {
		let {formatMessage} = this.context
		try {
			this.setState({spinner: true})
			await syncDemo();
			toastr.success(formatMessage('titleSyncTrSuccess'), formatMessage('messageSyncTrSuccess'));
			this.setState({spinner: false})
		} catch (error) {
			this.setState({spinner: false})
			toastr.error(formatMessage('titleSyncTrError'), formatMessage('messageSyncTrError'));
		}
	}

	syncProdClick = async() => {
		let {formatMessage} = this.context
		try {
			this.setState({spinner: true})
			await syncProd();
			toastr.success(formatMessage('titleSyncTrSuccess'), formatMessage('messageSyncTrSuccess'));
			this.setState({spinner: false})
		} catch (error) {
			this.setState({spinner: false})
			toastr.error(formatMessage('titleSyncTrError'), formatMessage('messageSyncTrError'));
		}
	}

  render() {
    let {translationsByMessageId, push} = this.props
		let {formatMessage} = this.context
		const {spinner} = this.state;
    return (
        <div style={{position: 'relative'}}>
					{spinner && <div style={{position: 'fixed', zIndex: 999, width: '1170px', background: 'rgba(255,255,255, 0.3)', height: 'calc(100vh - 76px)', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
						<Spiner />
					</div>}
            <div className="question-types-block question-types-block__mb question-types-block__right">
                <div
                    className="question-type question-type__sm"
                    onClick={() => push(`${routesUrls.adminTranslationsNew}`)}
                >
                    <span className="question-type-plus-icon">+</span> {formatMessage("Add new")}
                </div>
            </div>
            <div style={{marginBottom: 10}}>
                <button onClick={this.syncTestClick} className="btn btn-info">{formatMessage('txtSyncTestTranslate')}</button>
                {/* <button onClick={this.syncDemoClick} className="btn btn-info">{formatMessage('txtSyncDemoTranslate')}</button> */}
                {/* <button onClick={this.syncProdClick} className="btn btn-info">{formatMessage('txtSyncProdTranslate')}</button> */}
            </div>
            <Table striped bordered hover>
                <thead>
                <tr>
                    <th>#</th>
                    <th>{formatMessage('Message ID')}</th>
                    <th>en</th>
                    <th>de</th>
                </tr>
                </thead>
                <tbody>
                {
                    translationsByMessageId.map(({messageId, en, de}, index) => (
                        <tr
                            key={messageId}
                            className="pointer"
                            onClick={() => push(`${routesUrls.adminTranslations}/${encodeURIComponent(messageId)}`)}
                        >
                            <td>{index + 1}</td>
                            <td>{messageId}</td>
                            <td>{en}</td>
                            <td>{de}</td>
                        </tr>
                    ))
                }
                </tbody>
                <tfoot>
                <tr>
                    <th>#</th>
                    <th>{formatMessage('Message ID')}</th>
                    <th>en</th>
                    <th>de</th>
                </tr>
                </tfoot>
            </Table>
        </div>
    )
  }
}



export default connect(
    state => ({
        translationsByMessageId : translationsByMessageIdSelector(state),
    }),
    {push}
)(Translations)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Translations.js